// Webpack sets this environment variable when developing locally
export const isDevEnvironment = process.env.NODE_ENV === 'development';
